@import 'src/styles/variabels';
@import 'src/styles/mobile';

.root {
  display: grid;
  grid-template-columns: 6.4rem 1fr;
  align-items: end;
  width: 32rem;
  position: relative;
  z-index: 10;
  padding-bottom: 1rem;
}

.imageBox {
  display: grid;
  align-items: center;
  justify-content: center;
  img {
    display: block;
  }
}

.link {
  opacity: 0.5;
  transition: opacity 0.3s;
  img {
    display: block;
  }
  &:hover {
    opacity: 1;
    text-decoration: none;
  }
}

// PD-09 (R2): below md the drawer's paper is narrower than 32rem at 360 (it
// leaves the page 5.6rem), and the fixed width cut "Powered By" at its edge.
// N1 / T2: the drawer's footer is one row under a rule -- the language switch
// at the start, "Powered By" at the end. The candies mark belongs to the
// desktop's blue rail, which the mobile drawer does not have.
@media (max-width: map-get($breakpoints, 'md') - 1 + px) {
  .root {
    width: 100%;
    flex: none;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: $mobile-space-s;
    padding: $mobile-space-s $mobile-space-m;
    border-top: 1px solid $color-grey-lines;
  }
  .imageBox {
    display: none;
  }
}
